import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DoorOpen } from 'lucide-react';
import { useStandaloneFieldSx } from '../shared';
import CenterModal from './CenterModal';
import { useOpenCash } from './useCashActions';

// Abrir caixa — modal central (§5.6), mesmo padrão de
// `prototipo-lista-caixas.html`/`prototipo-painel-caixa.html`: valor inicial
// em espécie (obrigatório) + observação (opcional). Endpoint real:
// `POST /cashregister/{id}/open` (`cashregister/opener.go`), payload
// `{cash_register_id, amount_money, obs, start_operation}` — preservado 1:1
// do formulário de página cheia antigo (`pages/cashregisters/Open.js`), só a
// casca visual (modal em vez de página) e o gatilho (menu/ação, não mais
// rota dedicada) mudaram.
export default function OpenCashModal({ open, onClose, cashRegister, onSuccess, onError }) {
    const standaloneFieldSx = useStandaloneFieldSx();
    const { amount, obs, setObs, amountError, saving, changeAmount, confirm: handleConfirm } = useOpenCash({ open, cashRegister, onSuccess, onError });

    return (
        <CenterModal
            open={open}
            onClose={onClose}
            icon={DoorOpen}
            iconBg="success.bg"
            iconColor="success.main"
            title="Abrir Caixa"
            description={cashRegister ? `Informe o valor inicial em espécie para abrir o terminal "${cashRegister.name}".` : ''}
            onConfirm={handleConfirm}
            confirmText="Abrir caixa"
            loading={saving}
        >
            <Box sx={{ mb: 2 }}>
                <TextField
                    autoFocus
                    fullWidth
                    label="Valor inicial em espécie (R$) *"
                    value={amount}
                    onChange={(e) => changeAmount(e.target.value)}
                    error={Boolean(amountError)}
                    helperText={amountError}
                    variant="outlined"
                    sx={standaloneFieldSx}
                />
            </Box>
            <Box>
                <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    label="Observação"
                    value={obs}
                    onChange={(e) => setObs(e.target.value)}
                    variant="outlined"
                    sx={standaloneFieldSx}
                />
            </Box>
        </CenterModal>
    );
}
